import { CSSProperties } from "react"
import { css, cx, keyframes } from "@emotion/css"

const pulse = keyframes`
  0% {

    background: var(--start-color);
  };

  100% {
    background: var(--end-color);
  }
`

const styles = {
  root: css`
    opacity: 0.7;
    margin: 6px 0;
    pointer-events: none;
    user-select: none;
    border-radius: 2px;
    background: padding-box var(--end-color);
    animation: 0.8s linear 0s infinite alternate none running ${pulse};
  `,
}

type SkeletonProps = {
  startColor?: string
  endColor?: string
  width?: CSSProperties["width"]
  height?: CSSProperties["height"]
  className?: string
}
export function Skeleton(props: SkeletonProps) {
  const {
    startColor = "#e7e6e6",
    endColor = "#a8a8a8",
    width = "100%",
    height = "20px",
    className,
  } = props

  const style = {
    width,
    height,
    "--start-color": startColor,
    "--end-colot": endColor,
  } as CSSProperties
  return <div className={cx(styles.root, className)} style={style} />
}
